import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes } from '@angular/router';
import { ApplicationComponent } from './components/application/application.component';
import { RegisterUserComponent } from './components/register-user/register-user.component';
import { SigninComponent } from './components/signin/signin.component';
import { AuthGuard } from './services/auth.guard';
import { UserComponent } from './components/user/user.component';
import { RoleComponent } from './components/role/role.component';
import { WorkInProgressComponent } from './components/work-in-progress/work-in-progress.component';
import { ActivityControlsComponent } from './components/activity-controls/activity-controls.component';
import { FlightComponent } from './components/flight/flight.component';
import { SettingsComponent } from './components/settings/settings.component';
import { UserUpdateComponent } from './components/user-update/user-update.component';
import { TerminalComponent } from './components/terminal/terminal.component';
import { TicketIssuanceComponent } from './components/ticket-issuance/ticket-issuance.component';
import { ConfigComponent } from './components/config/config.component';
import { AirConfigComponent } from './components/air-config/air-config.component';
import { UserConfigComponent } from './components/user-config/user-config.component';
import { FlightlistComponent } from './components/flightlist/flightlist.component';
import { AirManagementComponent } from './components/air-management/air-management.component';
import { AmadeusComponent } from './components/amadeus/amadeus.component';
import { BookingComponent } from './components/booking/booking.component';
import { PaymentConfigComponent } from './components/payment-config/payment-config.component';
import { DataEncryptionComponent } from './components/data-encryption/data-encryption.component';
import { DataSecurityComponent } from './components/data-security/data-security.component';
import { HotelComponent } from './components/hotel/hotel.component';
import { ReportingConfigComponent } from './components/reporting-config/reporting-config.component';
import { CommercialsComponent } from './components/commercials/commercials.component';
import { TestComponent } from './components/test/test.component';
import { ManageCartsComponent } from './components/manage-carts/manage-carts.component';
import { HotelListComponent } from './components/hotel-list/hotel-list.component';
import { ManualCartComponent } from './components/manual-cart/manual-cart.component';
import { MulitiCityFlightlistComponent } from './components/muliti-city-flightlist/muliti-city-flightlist.component';
import { HotelBookingComponent } from './components/hotel-booking/hotel-booking.component';
import { ResetPasswdComponent } from './components/reset-passwd/reset-passwd.component';
import { RaisedTicketComponent } from './components/raised-ticket/raised-ticket.component';
import { ManualBookingComponent } from './components/manual-booking/manual-booking.component';
import { ModifyCartComponent } from './components/modify-cart/modify-cart.component';
// import { HotelConfigComponent } from './components/hotel-config/hotel-config.component';
import { AgentDashboardComponent } from './components/agent-dashboard/agent-dashboard.component';
import { AgentPaymentConfirmComponent } from './components/agent-payment-confirm/agent-payment-confirm.component';
import { AgentPaymentCancelComponent } from './components/agent-payment-cancel/agent-payment-cancel.component';
import { HotelModifyCartComponent } from './components/hotel-modify-cart/hotel-modify-cart.component';
import { HotelDetailsComponent } from './components/hotel-details/hotel-details.component';
import { MergeHotelDetailComponent } from './components/merge-hotel-detail/merge-hotel-detail.component';
import { ManageFileUploadComponent } from './components/manage-file-upload/manage-file-upload.component';
import { TripComponent } from './components/trip/trip.component';
import { DocSopComponent } from './components/doc-sop/doc-sop.component';
import { DocPolicyComponent } from './components/doc-policy/doc-policy.component';
import { TripSummaryComponent } from './components/trip-summary/trip-summary.component';
import { ManageExpenceComponent } from './manage-expence/manage-expence.component';
import { ApprovalTripComponent } from './components/approval-trip/approval-trip.component';
import { CalendarCartComponent } from './components/calendar-cart/calendar-cart.component';
import { IntlFlightListComponent } from './components/intl-flight-list/intl-flight-list.component';
import { BusComponent } from './components/bus/bus.component';
import { BusinessGroupComponent } from './components/business-group/business-group.component';
// import { GilpinVisaComponent } from './components/gilpin-visa/gilpin-visa.component';
import { TravelPoliciesComponent } from './components/travel-policies/travel-policies.component';
import { TravelDeskComponent } from './components/travel-desk/travel-desk.component';
import { HotelManualBookingComponent } from './components/hotel-manual-booking/hotel-manual-booking.component';
import { HotelManagementComponent } from './components/hotel-management/hotel-management.component';
// import { MultiCityFlightlistComponent } from './components/multi-city-flightlist/multi-city-flightlist.component';
import { TagsCardComponent } from './components/tags-card/tags-card.component';
import { InsuranceComponent } from './components/insurance/insurance/insurance.component';
import { InsuranceListComponent } from './components/insurance/insurance-list/insurance-list.component';
import { NotificationSettingsComponent } from './components/notification-settings/notification-settings.component';
import { InsuranceBookingComponent } from './components/insurance/insurance-booking/insurance-booking.component';
import { PaymentContractComponent } from './components/payment-contract/payment-contract.component';
import { InsuranceModifyCartComponent } from './components/insurance/insurance-modify-cart/insurance-modify-cart.component';

const routes: Routes = [
    {path:"app",component : ApplicationComponent,canActivate : [AuthGuard],canActivateChild : [AuthGuard], 
      children : [
        
        {path:"Notifications",component : NotificationSettingsComponent},

        {path:"progress",component : WorkInProgressComponent},
        {path:"manage-file-upload",component : ManageFileUploadComponent},
        {path:"calendar-cart",component : CalendarCartComponent},
        {path:"payment-contract/:token",component : PaymentContractComponent},
        {path:"bus",component : BusComponent},
        {path:"Business Group",component : BusinessGroupComponent},

        
        {path:"trip",component : TripComponent},
        {path:"trip-summary",component : TripSummaryComponent},
        
        // {path:"visa",component : GilpinVisaComponent},

        {path:"manage-expence",component : ManageExpenceComponent},
        {path:"Trip-Summary/:token",component : TripSummaryComponent,pathMatch:"full"},

        {path:"Users",component : UserComponent},
        {path:"Role",component : RoleComponent},
        {path:"traveller-Role",component : TravelDeskComponent},


        {path:"flight",component : FlightComponent},
        {path:"insurance",component : InsuranceComponent},

        {path:"hotel",component : HotelComponent},
        {path:"settings",component : SettingsComponent},
        {path:"travel_policies",component : TravelPoliciesComponent},

        
        {path:"User",component : UserUpdateComponent},
        {path:"terminal",component : TerminalComponent},
        {path:"book",component : BookingComponent},
        {path:"insurance-book",component : InsuranceBookingComponent},

        {path:"view-cart",component : HotelModifyCartComponent},
        {path:"modifyCart",component : HotelModifyCartComponent},
        {path:"SOP",component : DocSopComponent,pathMatch:"full"},
        {path:"Travel Policy",component : DocPolicyComponent,pathMatch:"full"},
        {path:"hotel-detail/:token",component : HotelDetailsComponent,pathMatch:"full"},

        
        {path:"payment-config",component : PaymentConfigComponent},
        {path:"data-security",component : DataSecurityComponent},
        {path:"reporting-config",component : ReportingConfigComponent},
        {path:"commercials",component : CommercialsComponent},
        {path:"print",component : TestComponent},
        {path:"manage-carts",component : ManageCartsComponent},
        {path:"create-manual-cart",component : ManualCartComponent},
        {path:"manual-booking",component : ManualBookingComponent},
        
        {path:"modify-cart",component : ModifyCartComponent},
        {path:"modify-Insurance-Cart",component : InsuranceModifyCartComponent},
        {path:"view-Insurance-Cart",component : InsuranceModifyCartComponent},

        {path:"hotelbooking",component : HotelBookingComponent},
        {path:"manual-Booking",component : HotelManualBookingComponent},
        {path:"raisedTicket",component : RaisedTicketComponent},
        {path:"agent-dashboard",component : AgentDashboardComponent},

        
        {path:"Activity",component : ActivityControlsComponent},
        {path:"hotellist",component : HotelListComponent},
        {path:"flightlist",component : FlightlistComponent},
        {path:"insurancelist",component : InsuranceListComponent},
        {path:"flight-intl-list",component : IntlFlightListComponent},

        {path:"flightList",component : MulitiCityFlightlistComponent},
        {path:"Hotel-Management",component : HotelManagementComponent},
        {path:"Air-Management",component : AirManagementComponent,canActivate : [AuthGuard],canActivateChild : [AuthGuard], 
        children : [
          {path:"Amadeus",component : AmadeusComponent},
        ]},
        {path:"User-config",component : UserConfigComponent},
        // {path:"Hotel-config",component : HotelConfigComponent},
        {path:"Air-config",component : AirConfigComponent},
        {path:"Tag-config",component : TagsCardComponent},

        {path:"config",component : ConfigComponent },

        

  ]},
  {path:"approval-trip/:token",component : ApprovalTripComponent,pathMatch:"full"},
  {path:"reject-trip/:token",component : ApprovalTripComponent,pathMatch:"full"},

  {path:"payment/payment/cca/confirm/:token",component : AgentPaymentConfirmComponent,pathMatch:"full"},
  {path:"payment/payment/cca/cancel/:token",component : AgentPaymentCancelComponent,pathMatch:"full"},

// {path:"",component : SigninComponent},
//{path:"sign-in",component : SigninComponent},
{path:"reset_password",component : ResetPasswdComponent},
  {path:"partner_login",component : SigninComponent},
  {path:"corporate_login",component : SigninComponent},
  {path:"register-user",component : RegisterUserComponent},
  {path:"",redirectTo:"partner_login",pathMatch:"full"}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { 
  
}
